import Vue from 'vue';

const eventBus = new Vue();

export default eventBus;



// WEBPACK FOOTER //
// ./src/EventBus.js